"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'password.reset.hero.title': 'Zapomniałeś hasła?',
    'password.reset.hero.description': 'Nie martw się, zdarza się każdemu. Wpisz swój adres email, a wyślemy Ci link do zresetowania hasła.',
    'password.reset.hero.login_link_text': 'Przypomniałeś sobie hasło?',
    'password.reset.hero.login_link': 'Zaloguj się tutaj',
    'password.reset.page.title': 'Resetowanie Hasła',
    'password.reset.form.title': 'Zresetuj Swoje Hasło',
    'password.reset.email.label': 'Adres Email',
    'password.reset.email.placeholder': 'Wpisz swój adres email',
    'password.reset.submit': 'Wyślij Link Resetowania',
    'password.reset.backToLogin': 'Powrót do Logowania',
    'password.reset.success.title': 'Email Wysłany!',
    'password.reset.success.description': 'Sprawdź swoją skrzynkę email, aby uzyskać instrukcje resetowania hasła.',
    'password.reset.confirm.hero.title': 'Ustaw Nowe Hasło',
    'password.reset.confirm.hero.description': 'Stwórz silne hasło, które zapamiętasz. Twoje nowe hasło powinno różnić się od poprzedniego.',
    'password.reset.confirm.hero.login_link_text': 'Przypomniałeś sobie hasło?',
    'password.reset.confirm.hero.login_link': 'Zaloguj się tutaj',
    'password.reset.confirm.page.title': 'Ustaw Nowe Hasło',
    'password.reset.confirm.form.title': 'Stwórz Nowe Hasło',
    'password.reset.confirm.password.label': 'Nowe Hasło',
    'password.reset.confirm.password.placeholder': 'Wpisz nowe hasło',
    'password.reset.confirm.confirmPassword.label': 'Potwierdź Hasło',
    'password.reset.confirm.confirmPassword.placeholder': 'Potwierdź nowe hasło',
    'password.reset.confirm.submit': 'Zresetuj Hasło',
    'password.reset.confirm.success.title': 'Hasło Zresetowane!',
    'password.reset.confirm.success.description': 'Twoje hasło zostało pomyślnie zresetowane. Możesz teraz zalogować się swoim nowym hasłem.',
    'password.reset.title': 'Resetuj Hasło',
    'password.reset.description': 'Podaj swój adres e-mail, a wyślemy Ci link do resetowania hasła.',
    'password.reset.failed': 'Nie udało się wysłać e-maila resetującego',
    'password.reset.sent': 'E-mail resetujący hasło został wysłany pomyślnie',
    'password.reset.confirm.title': 'Ustaw Nowe Hasło',
    'password.reset.confirm.description': 'Podaj swoje nowe hasło poniżej.',
    'password.reset.confirm.failed': 'Nie udało się zresetować hasła',
    'password.reset.confirm.success': 'Hasło zostało pomyślnie zresetowane',
    'password.reset.confirm.mismatch': 'Hasła nie są identyczne',
    'password.reset.confirm.length': 'Hasło musi mieć co najmniej 6 znaków',
};
